"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _merge = _interopRequireDefault(require("lodash/merge"));
var _theme = _interopRequireDefault(require("@chakra-ui/theme"));
const overrides = {
  defaultProps: {
    colorScheme: 'primary',
    size: 'lg'
  },
  baseStyle: props => (0, _merge.default)(_theme.default.components.Switch.baseStyle(props), {
    track: {
      bg: 'gray.medium',
      overflow: 'clip'
    },
    thumb: {
      transition: 'all 150ms ease',
      boxShadow: 'base',
      _hover: {
        boxShadow: 'md'
      }
    }
  })
};
var _default = exports.default = {
  ..._theme.default.components.Switch,
  ...overrides
};